module.exports = Object.freeze({
    USER_DATA: 'U2FsdGVkX19+pmscS0yke+7VF+GQs',
    ACCESS_TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
    REFRESH_TOKEN: 'U2FsdGVkX1+44edyO9gsMPJdGridH',
    ROUTER: 'routers',
    NAVIGATION: 'navigation',
    PASSWORD: '5f4dcc3b5aa765d61d8327deb882cf99',
    USERNAME: '27087b329deeade828edd652d45461b2',
});